import React, { useContext, useEffect, useState } from 'react'
import { DcOverlaySlider, PixelFactoryContext, PixelTable } from 'pixel-base'
import { getJournals } from 'utils/api-routes.util'
import AddNewJournal from './components/AddNewJournal'
import FinancePageShell from '../../components/FinancePageShell'

interface PixelFactory {
  showPageLoader?: () => void
  hidePageLoader?: () => void
}

const Journal = () => {
  const pixelFactory = useContext(PixelFactoryContext) as PixelFactory
  const [tableData, setTableData] = useState<Record<string, any>[]>([])
  const [isShowSpinner, setIsShowSpinner] = React.useState(false)
  const [showAddNew, setShowAddNew] = useState(false)

  useEffect(() => {
    pixelFactory?.showPageLoader?.()
    setIsShowSpinner(true)

    const subscription = getJournals().subscribe({
      next: (res) => {
        setTableData(res.response?.data || [])
        setIsShowSpinner(false)
      },
      error: (error) => {
        console.error('Error fetching journals:', error)
        setTableData([])
        setIsShowSpinner(false)
      },
      complete: () => {
        pixelFactory?.hidePageLoader?.()
      },
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [pixelFactory])

  const columns = [
    {
      name: 'Code',
      selector: (row) => row.code || row.short_code || '--',
    },
    {
      name: 'Name',
      selector: (row) => row.name || '--',
    },
    {
      name: 'Type',
      selector: (row) => {
        const value = row.journal_type || row.type || '--'
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
    },
    {
      name: 'Currency',
      selector: (row) => row.currency_code || row.currency || 'PKR',
    },
    {
      name: 'Status',
      selector: (row, index) => (
        <span
          data-testid={`row-${index + 1}-status`}
          style={{
            color: row.is_active ?? row.active ?? true ? '#2ecc71' : '#e74c3c',
          }}
        >
          {row.is_active ?? row.active ?? true ? 'Active' : 'Inactive'}
        </span>
      ),
    },
  ]

  return (
    <>
      <FinancePageShell
        title="Journals"
        isLoading={isShowSpinner}
        primaryAction={{ label: 'Add New', onClick: () => setShowAddNew(true) }}
      >
        {tableData.length > 0 ? (
          <PixelTable
            columns={columns}
            data={tableData}
            pagination
            searchable
            sortable
            fixedHeader
            fixedHeaderScrollHeight="calc(100vh - 238px)"
            data-testid="pixel-table"
          />
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
              fontSize: '16px',
              color: '#666',
            }}
          >
            {isShowSpinner ? 'Loading...' : 'No journals found'}
          </div>
        )}
      </FinancePageShell>
      <DcOverlaySlider
        isOpen={showAddNew}
        onClose={() => setShowAddNew(false)}
        title="Add New Journal"
        width="32%"
      >
        <AddNewJournal
          onClose={() => setShowAddNew(false)}
          onSuccess={() => {
            setShowAddNew(false)
          }}
        />
      </DcOverlaySlider>
    </>
  )
}

export default Journal
